/* eslint-disable prefer-template */

export function get(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }

    return undefined;
}

export function set(name, domain, path = '/', value = '1') {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);

    document.cookie = encodeURIComponent(name) +
                  '=' + value + '; expires=' + date.toGMTString() +
                  (domain ? '; domain=' + domain : '') +
                  (path ? '; path=' + path : '');
}



/** WEBPACK FOOTER **
 ** ./assets/js/cookie.js
 **/